// extracted by mini-css-extract-plugin
export default {"specialPagesContainer":"SpecialPages_specialPagesContainer__2ipB-","header":"SpecialPages_header__Unlmq"};